module.exports = __webpack_public_path__ + "8c5eb8e15580bf53be3aaf4d6e9a26db.svg";